import { render, staticRenderFns } from "./HealthInfo.vue?vue&type=template&id=07efb9eb&"
import script from "./HealthInfo.vue?vue&type=script&lang=js&"
export * from "./HealthInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports